export default "__VITE_ASSET__BMhQOfh4__"